/**
 * @link https://stackoverflow.com/a/16861050
 */
export function popupCenter(options: { url: string; title: string; width: number; height: number }) {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - options.width) / 2 / systemZoom + dualScreenLeft;
  const top = (height - options.height) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(
    options.url,
    options.title,
    `
      scrollbars=yes,
      width=${options.width / systemZoom}, 
      height=${options.height / systemZoom}, 
      top=${top}, 
      left=${left}
    `
  );

  newWindow?.focus();
}
